import { Link } from "react-router-dom";
import { Reveal, Label } from "./ui-bits";

export default function PageHero({ label, title, lede, safety = true, meta }) {
  return (
    <section className="pt-36 pb-16 sm:pt-44 sm:pb-20 px-5 sm:px-8">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <Label>{label}</Label>
        </Reveal>
        <Reveal delay={0.08}>
          <h1 className="font-display font-semibold text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight mt-6 max-w-4xl">
            {title}
          </h1>
        </Reveal>
        {lede && (
          <Reveal delay={0.16}>
            <p className="text-mute text-base sm:text-lg leading-relaxed mt-6 max-w-2xl">{lede}</p>
          </Reveal>
        )}
        {meta && (
          <Reveal delay={0.22}>
            <div className="flex flex-wrap gap-3 mt-8">{meta}</div>
          </Reveal>
        )}
        {safety && (
          <Reveal delay={0.26}>
            <p className="mono-label text-dusk mt-10">{`Treatment is subject to individual clinical assessment.`}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
